var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 54,
    viewBox: "0 0 75 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0708 53.285H2.92917C1.31167 53.285 0 51.9733 0 50.3558V2.92917C0 1.31167 1.31167 0 2.92917 0H72.0708C73.6883 0 75 1.31167 75 2.92917V50.3558C75 51.9733 73.6883 53.285 72.0708 53.285Z",
    fill: "#F3AC47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 20.748L0.924988 52.483C1.44915 52.9772 2.15165 53.2855 2.92915 53.2855H72.0708C72.8483 53.2855 73.5508 52.9772 74.075 52.483C72.315 50.9564 37.5 20.748 37.5 20.748Z",
    fill: "#F19A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.631653 1.1325L37.5 32.5375L74.075 0.802499C73.5508 0.308333 72.8483 0 72.0708 0H2.92915C1.99249 0 1.16749 0.447499 0.631653 1.1325Z",
    fill: "#FFD15C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.3ff60603df48c7ddd22bccfba59f33cc.svg";
export { ForwardRef as ReactComponent };